import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import classNames from 'classnames/bind'
import { CausesPortalLogo, Footer, Loader } from '@percent/cause-dashboard/common/components'
import { useQuery, useSitewideMessage } from '@percent/cause-dashboard/common/hooks'
import { useServices } from '@percent/cause-dashboard/context/serviceContext/ServiceContext'
import styles from '../agentVerificationDocuments/AgentVerificationDocuments.module.scss'
import { ValidationRequestDocumentsForm } from './ValidationRequestDocumentsForm'
import { ValidationRequestDocumentsStatus } from './ValidationRequestDocumentsStatus'

const cx = classNames.bind(styles)

const INVALID_LINK_ERROR_CODE = 'validation_request_document_upload/invalid_token'

export const ValidationRequestDocumentsContainer = () => {
  const { shouldShowSitewideMessage } = useSitewideMessage()
  const [documentsSubmitted, setDocumentsSubmitted] = useState(false)
  const [uploadClosed, setUploadClosed] = useState(false)
  const { search } = useLocation()
  const { validationRequestDocumentsService } = useServices()

  const validationRequestToken = new URLSearchParams(search).get('token') || ''

  const [{ data, isLoading, error }, { refresh }] = useQuery(
    validationRequestDocumentsService.getValidationRequestDocumentStatus,
    validationRequestToken
  )
  const status = data?.data

  const hasToken = validationRequestToken !== ''

  if (hasToken && isLoading && !status) return <Loader />

  const renderContent = () => {
    if (documentsSubmitted) {
      return <ValidationRequestDocumentsStatus status="submitted" partnerBanner={status?.partnerBanner} />
    }

    if (
      !hasToken ||
      uploadClosed ||
      error?.code === INVALID_LINK_ERROR_CODE ||
      (status && !status.awaitingDocumentUpload)
    ) {
      return <ValidationRequestDocumentsStatus status="closed" partnerBanner={status?.partnerBanner} />
    }

    if (!status) {
      return <ValidationRequestDocumentsStatus status="loadError" onRetry={refresh} />
    }

    return (
      <ValidationRequestDocumentsForm
        validationRequestToken={validationRequestToken}
        status={status}
        onDocumentsSubmitted={() => setDocumentsSubmitted(true)}
        onUploadClosed={() => setUploadClosed(true)}
      />
    )
  }

  return (
    <div
      className={cx({
        agentVerificationDocumentsContainerDefault: !shouldShowSitewideMessage,
        agentVerificationDocumentsContainerWithBanner: shouldShowSitewideMessage
      })}
    >
      <CausesPortalLogo />
      {renderContent()}

      <div className={styles.footerWrapper}>
        <Footer />
      </div>
    </div>
  )
}
